import dayjs from "dayjs";
import {
  IPublicHolidaysEntity,
  IPublicHolidaysRequest,
  IPublicHolidaysResponse,
} from "../shared/types";

import { BaseServiceLegacy } from "./base.service.legacy";
import { getUtcMidnightDayjs, toMexicoStartOfDay } from "../shared/helpers";

export class PublicHolidaysService extends BaseServiceLegacy<
  IPublicHolidaysResponse,
  IPublicHolidaysRequest
> {
  constructor() {
    super("/public-holidays");
  }

  public transformEntityToRequest(
    entity: IPublicHolidaysEntity
  ): IPublicHolidaysRequest {
    return {
      ...entity,
      publicHolidays: entity.publicHolidays.map((publicHoliday) =>
        getUtcMidnightDayjs(publicHoliday).toISOString()
      ),
    };
  }

  public transformResponseToEntity(
    response: IPublicHolidaysResponse
  ): IPublicHolidaysEntity {
    return {
      ...response,
      publicHolidays: response.publicHolidays.map((publicHoliday) =>
        dayjs(publicHoliday)
      ),
      createdAt: new Date(response.createdAt),
      updatedAt: new Date(response.updatedAt),
    };
  }
}
